
import * as React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip'
import TelephoneIcon from '@mui/icons-material/Call';

const TelephoneChip = ({ label }) => <Chip icon={<TelephoneIcon />} label={label} />;

TelephoneChip.propTypes = {
    label: PropTypes.string.isRequired
};

export default TelephoneChip;